"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IterableSet = void 0;
const ChainableIterator_1 = require("./ChainableIterator");
class IterableSet extends Set {
    iterValues() {
        return new ChainableIterator_1.ChainableIterator(super.values());
    }
    static from(values) {
        return new IterableSet(values);
    }
}
exports.IterableSet = IterableSet;
//# sourceMappingURL=IterableSet.js.map